import { gql } from "@apollo/client";

export const QUERY_ASSIGNED_LOADS_SUMMARY = gql`
  query MyQuery($assignedLoads: Boolean, $loadOrInvoiceOrDebtorOrStatus: String) {
    fundingRequestsSummary(
      assignedLoads: $assignedLoads
      loadOrInvoiceOrDebtorOrStatus: $loadOrInvoiceOrDebtorOrStatus
    ) {
      data
    }
  }
`;
